/**
 * Size guide — Women / Men tab switching for the image-based size charts. The active tab is
 * reflected in the URL hash (#women / #men) so a tab is directly linkable.
 */

/** @param {Element} section @param {string} slug @param {boolean=} updateHash */
function szcActivate(section, slug, updateHash) {
  const panel = section.querySelector(`[data-szc-panel="${CSS.escape(slug)}"]`);
  if (!(panel instanceof HTMLElement)) return false;
  section.querySelectorAll('[data-szc-panel]').forEach((p) => {
    if (p instanceof HTMLElement) p.hidden = p !== panel;
  });
  section.querySelectorAll('[data-szc-tabs] [data-szc-tab]').forEach((tab) => {
    if (!(tab instanceof HTMLElement)) return;
    const on = tab.dataset.szcTab === slug;
    tab.classList.toggle('is-active', on);
    tab.setAttribute('aria-selected', on ? 'true' : 'false');
    tab.tabIndex = on ? 0 : -1;
  });
  if (updateHash) history.replaceState(null, '', `#${slug}`);
  return true;
}

/** @param {Element} section */
function szcInit(section) {
  section.querySelectorAll('[data-szc-tabs] [data-szc-tab]').forEach((tab) => {
    if (!(tab instanceof HTMLElement) || tab.dataset.szcReady === 'true') return;
    tab.addEventListener('click', () => {
      if (tab.dataset.szcTab) szcActivate(section, tab.dataset.szcTab, true);
    });
    tab.dataset.szcReady = 'true';
  });

  const hash = decodeURIComponent((location.hash || '').replace(/^#/, ''));
  if (!(hash && szcActivate(section, hash, false))) {
    const first = section.querySelector('[data-szc-panel]');
    if (first instanceof HTMLElement && first.dataset.szcPanel) szcActivate(section, first.dataset.szcPanel, false);
  }
}

function szcInitAll() {
  document.querySelectorAll('.size-chart').forEach(szcInit);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', szcInitAll);
} else {
  szcInitAll();
}

window.addEventListener('hashchange', () => {
  const slug = decodeURIComponent((location.hash || '').replace(/^#/, ''));
  if (!slug) return;
  document.querySelectorAll('.size-chart').forEach((section) => szcActivate(section, slug, false));
});

document.addEventListener('shopify:section:load', szcInitAll);
